import { workbookService } from "./workbook.service";

export const workbookChartService = workbookService.injectEndpoints({
  endpoints: (builder) => ({
    getGannWheelAspects: builder.query({
      query: (data) => ({
        url: "/gann-wheel/aspects",
        method: "POST",
        data
      }),
      transformResponse: (response) => response.data,
      providesTags: ["GannWheelAspects"]
    }),
  }),
});

export const {
  useLazyGetGannWheelAspectsQuery
} = workbookChartService;
